var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-produced-page wt2-sg",on:{"mousemove":_vm.onProducedMove,"mouseleave":_vm.onProducedLeave}},[_c('produced-content',{attrs:{"timeout-control-time":_vm.timeoutControlTime,"canPlay":_vm.canPlay,"video":_vm.video}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }